exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.nil-sa-elements-creditcardicon-style__icon{display:flex!important;align-items:center;width:60px}div.nil-sa-elements-creditcardicon-style__icon img{width:100%}", ""]);

// exports
exports.locals = {
	"icon": "nil-sa-elements-creditcardicon-style__icon"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/elements/CreditCardIcon/style.less
// module id = 413
// module chunks = 0